<template>
  <hgroup class="header">
    <h1>Unsere Auswahl</h1>
    <h2>Für
      <span v-if="selectedOptions[0].findIndex(element => element === 's1_sie') >= 0">Sie</span><span v-else-if="selectedOptions[0].findIndex(element => element === 's1_du') >= 0">Dich</span>,
      {{ name }}
    </h2>
  </hgroup>
  <div class="body">
    <div v-if="isError">Fehler</div>
    <div v-else-if="isLoading">Loading</div>
    <div v-else class="recommendations">
      <div v-for="item in recommendations.items" :key="item.id" class="item">
        <figure><img :src="item.image"></figure>
        <div class="title"><h4>{{ item.bezeichnung }}</h4><h5>{{ item.line }}</h5></div>
        <div class="link" v-if="item.url"><a :href="item.url" target="_blank" class="btn btn-shop">Zum Produkt</a></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FinderStep3',
  data () {
    return {
      isLoading: false,
      isError: false,
      recommendations: []
    }
  },
  computed: {
    name: {
      get() {
        return this.$store.state.name
      }
    },
    currentIndex: {
      get() {
        return this.$store.state.currentIndex
      },
      set(value) {
        this.$store.commit('setCurrentIndex', { currentIndex: value })
      }
    },
    options: {
      get() {
        return this.$store.state.options
      }
    },
    selectedOptions: {
      get() {
        return this.$store.state.selectedOptions
      },
      set(value) {
        this.$store.commit('setSelectedOptions', { selectedOptions: value })
      }
    },
    showNext: {
      get() {
        return this.$store.state.showNext
      },
      set(value) {
        this.$store.commit('setShowNext', { showNext: value })
      }
    }
  },
  methods: {
    async getRecommendations () {
      try {
        this.isLoading = true;
        let params = {
          'attributes': this.selectedOptions
        }
        const response = await this.$http.post(
        'https://www.affentaler.de/_weinfinder/getProducts', 
        params,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      this.recommendations = response.data
      } catch (err) {
        this.isError = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.currentIndex = 5
    this.recommendations = this.getRecommendations()
  },
  mounted() {
    for (let i = 0; i < this.currentIndex; i++) {
      if (this.selectedOptions[i] === undefined || !this.selectedOptions[i].length) {
        this.$router.push({ path: '/step' + i + 1 })
      }
    }
    if (this.options[this.currentIndex].bg) {
      document.body.style.backgroundColor = this.options[this.currentIndex].bg
    } else {
      document.body.style.removeProperty('backgroundColor')
    }
    if (this.selectedOptions[this.currentIndex] !== undefined && this.selectedOptions[this.currentIndex].length) {
      this.showNext = true
    } else {
      this.showNext = false
    }
  }
}
</script>
